import React, { useState, memo, useCallback } from 'react'
import SearchInput from '../../../../../inputs/SearchInput'
import AddCarCategoriesButton from '../../../../../buttons/AddCarCategoriesButton'

function CategorySearchBox({ search, carModels, setCarModels }) {
  const [search_value, setSearchValue] = useState('')

  const inputHandler = useCallback(async (e) => {
    setSearchValue(e.target.value)
    search(e.target.value)
  }, [])

  const submitSearch = async (e) => {
    e.preventDefault()
  }

  return (
    <div
      className={
        'bg-light-blue dark:bg-slate-800 dark:border-gray-700 dark:shadow-none py-4 sm:py-9 px-3 sm:px-8 w-full rounded-2xl border border-light-gray shadow-info-count block'
      }
    >
      <div className="grid sm:grid-cols-2 gap-6">
        <form className="flex items-center justify-center" onSubmit={submitSearch}>
          <SearchInput
            search_value={search_value}
            inputHandler={inputHandler}
            placeholder={'نام خودرو را وارد کنید'}
          />
        </form>

        <AddCarCategoriesButton carModels={carModels} setCarModels={setCarModels} />
      </div>
    </div>
  )
}

export default memo(CategorySearchBox)
